// extracted by mini-css-extract-plugin
export default {"header":"Header_header__5jNoZ","title":"Header_title__pASgB"};